import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Problem } from './components/Problem';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Imagine } from './components/Imagine';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream" data-id="element-0" data-mp="23ti864kkyuk7">
      <main className="w-full" data-id="element-1" data-mp="3ikr0s4yore8d">
        <Hero data-id="element-2" data-mp="3ijfu9xduvsdk" />
        <Stats data-id="element-3" data-mp="3ihv2ugmu8pjx" />
        <Problem data-id="element-4" data-mp="3mlj9mx3nbh44" />
        <BeforeAfter data-id="element-5" data-mp="3ml14faz09sk2" />
        <PainPoints data-id="element-6" data-mp="3mkhmvvd9p66k" />
        <Imagine data-id="element-7" data-mp="3mjzpuwis6nxl" />
        <Tomos data-id="element-8" data-mp="3mjgczu7zmpqf" />
        <Bonos data-id="element-9" data-mp="3rc9ca2kot5v4" />
        <Offer data-id="element-10" data-mp="3rbrayrj641gc" />
        <Guarantee data-id="element-11" data-mp="3rdapodp6e4g0" />
        <Testimonials data-id="element-12" data-mp="3rcsw5otwe4bs" />
        <About data-id="element-13" data-mp="3recc1ebn6dd1" />
        <FAQ data-id="element-14" data-mp="5yhgo69t1c8" />
        <FinalCTA data-id="element-15" data-mp="6hr7hlrojf6" />
      </main>
      <Footer data-id="element-16" data-mp="4n6o4eeqtbm" />
      <FloatingCTA triggerId="cta-trigger" data-id="element-17" data-mp="56n1goet9nj" />
      <PurchasePopup data-id="element-18" data-mp="2zld43f9knpe6" />
    </div>;
}